<script>
import { createNamespacedHelpers } from 'vuex';
import { ScTabs, ScTabItem } from '@intelipost-js/secure-components';
import NewPageBase from '../../../../components/new-page-base/NewPageBase.vue';
import BillingFilesTable from './components/BillingFilesTable.vue';
import BillingExtractionsTable from './components/BillingExtractionsTable.vue';
import BillingTemplatesTable from './components/BillingTemplatesTable.vue';

const { mapState, mapActions } = createNamespacedHelpers('recon/billing');

export default {
  name: 'PageMyBillingsFiles',
  data() {
    return {
      activeTab: parseInt(this.$route.query.activeTab, 10),
    };
  },
  methods: {
    ...mapActions(['loadBillingFiles', 'loadClientTemplates']),
  },
  computed: {
    ...mapState([
      'loadingBillingFiles',
      'loadingBillingTemplates',
      'billingUploadFiles',
      'billingExtractionFiles',
      'clientBillingTemplates',
    ]),
  },
  created() {
    this.loadBillingFiles();
    this.loadClientTemplates();
  },
  components: {
    ScTabs,
    ScTabItem,
    NewPageBase,
    BillingFilesTable,
    BillingExtractionsTable,
    BillingTemplatesTable,
  },
};
</script>

<template>
  <new-page-base
    class="page-billing-files"
    @back="$router.push({ name: 'billing-main-page' })"
    showBackText="Faturas">

    <template slot="titleLeft">
      Meus arquivos
    </template>
    <template slot="titleRight">
      <router-link class="button is-primary" :to="{ name: 'billing-upload-page' }">
        Adicionar fatura
      </router-link>
      <router-link class="button" :to="{ name: 'create-billing-template' }">
        Criar novo modelo
      </router-link>
    </template>
    <template slot="subtitleSection">
      Aqui você encontra todos as faturas adicionadas.
    </template>

    <section class="page-billing-files__content">
      <sc-tabs size="is-medium" class="is-primary" v-model="activeTab">
        <sc-tab-item id="billing-files-uploads" label="Faturas adicionadas">
          <billing-files-table :files="billingUploadFiles" :loading="loadingBillingFiles"/>
        </sc-tab-item>
        <sc-tab-item id="billing-files-extractions" label="Faturas exportadas">
          <billing-extractions-table :files="billingExtractionFiles" :loading="loadingBillingFiles"/>
        </sc-tab-item>
        <sc-tab-item id="billing-files-templates" label="Modelos de fatura">
          <billing-templates-table :templates="clientBillingTemplates" :loading="loadingBillingTemplates"/>
        </sc-tab-item>
      </sc-tabs>
    </section>

  </new-page-base>
</template>

<style lang="scss">
@import "~@intelipost-js/secure-ui/src/scss/variables"; //eslint-disable-line
.page-billing-files {

  .button {
    font-weight: 700;
  }

  &__content {
    margin-top: 1.5em;

    .b-tabs {
      .tabs li.is-active a {
        border-bottom-color: $primary;
        color: $primary;
        font-weight: 700;
      }

      .tab-content {
        padding: 0 !important;
        padding-top: 1em !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/billing/pages/files/PageMyBillingsFiles.vue?b8042c6a